import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/App";

/**
 * Lightweight country-list fetcher. Caches the result in-module for the
 * lifetime of the page load. Used by Map, Submit, Profile, Admin Banks.
 */
let _cachedCountries = null;
let _inflight = null;

export function useCountries() {
  const [countries, setCountries] = useState(_cachedCountries || []);
  const [loading, setLoading] = useState(!_cachedCountries);

  useEffect(() => {
    if (_cachedCountries) {
      setCountries(_cachedCountries);
      setLoading(false);
      return;
    }
    if (!_inflight) {
      _inflight = axios
        .get(`${API}/countries`)
        .then((res) => {
          _cachedCountries = res.data || [];
          return _cachedCountries;
        })
        .catch(() => {
          _cachedCountries = [];
          return _cachedCountries;
        })
        .finally(() => {
          _inflight = null;
        });
    }
    _inflight.then((data) => {
      setCountries(data);
      setLoading(false);
    });
  }, []);

  return { countries, loading };
}

export function findCountry(countries, code) {
  if (!code) return null;
  return countries.find((c) => c.code === code) || null;
}
